import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useCart } from "../context/CartContext";
import { logger } from "../lib/logger";

// Rebuilds the bag from a reminder-email link: /cart?restore=<productId>:<qty>,...
export const useCartRestore = () => {
  const [params, setParams] = useSearchParams();
  const { items, addItem } = useCart();
  const done = useRef(false);
  const restore = params.get("restore");

  useEffect(() => {
    if (!restore || done.current) return;
    done.current = true;
    const wanted = restore.split(",").map((p) => p.split(":")).filter(([id, q]) => id && Number(q) > 0);
    api.get("/products")
      .then(({ data }) => {
        wanted.forEach(([id, q]) => {
          const prod = data.find((p) => p.id === id);
          const buyable = prod && !["coming_soon", "sold_out"].includes(prod.status) && prod.stock > 0;
          if (buyable && !items.some((i) => i.product_id === id)) addItem(prod, Math.min(Number(q), 20));
        });
      })
      .catch((e) => logger.warn("cart restore failed", e))
      .finally(() => setParams({}, { replace: true }));
  }, [restore, items, addItem, setParams]);
};
